import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Asset } from '../../types/common';

export interface AssetState {
  shapes: Asset[];
  stickers: Asset[];
  backgrounds: Asset[];
  frames: Asset[];
  clipart: Asset[];
}

const initialState: AssetState = {
  frames: [],
  clipart: [],
  shapes: [],
  stickers: [],
  backgrounds: [],
};

export const assetSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setShapes: (state, action: PayloadAction<Asset[]>) => {
      state.shapes = [...action.payload];
    },
    setStickers: (state, action: PayloadAction<Asset[]>) => {
      state.stickers = [...action.payload];
    },
    setFrames: (state, action: PayloadAction<Asset[]>) => {
      state.frames = [...action.payload];
    },
    setClipart: (state, action: PayloadAction<Asset[]>) => {
      state.clipart = [...action.payload];
    },
    setBackgrounds: (state, action: PayloadAction<Asset[]>) => {
      state.backgrounds = [...action.payload];
    },
  },
});

export const { setShapes, setStickers, setBackgrounds, setFrames, setClipart } = assetSlice.actions;

export default assetSlice.reducer;
